(function () {
  /**
   * After the age gate is dismissed, focused nodes from the age-gate overlay
   * are removed from the DOM and focus falls to browser chrome. Reset focus to
   * body so the next Tab lands on the skip-to-content link.
   */
  const AGE_GATE_ID = 'diageo-agegate-wrap';

  function watchForAgeGateDismissal() {
    const existingAgeGate = document.getElementById(AGE_GATE_ID);
    if (!existingAgeGate) return;

    const dismissalObserver = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        for (const removedNode of mutation.removedNodes) {
          if (!(removedNode instanceof Element)) continue;
          if (removedNode.id !== AGE_GATE_ID) continue;

          dismissalObserver.disconnect();
          if (!document.body.hasAttribute('tabindex')) {
            document.body.setAttribute('tabindex', '-1');
          }
          document.body.focus({ preventScroll: true });
          return;
        }
      }
    });

    dismissalObserver.observe(document.body, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForAgeGateDismissal);
  } else {
    watchForAgeGateDismissal();
  }

  const insertionObserver = new MutationObserver(function () {
    if (!document.getElementById(AGE_GATE_ID)) return;

    insertionObserver.disconnect();
    watchForAgeGateDismissal();
  });

  insertionObserver.observe(document.body || document.documentElement, { childList: true });
})();
